import React, {useState} from "react";
import {useAuth} from "../../utils/hooks/useAuth";
import NavButton from "./NavButton";
import {Avatar, Box, Divider, IconButton, Menu, MenuItem, Tooltip, Typography} from "@mui/material";
import {Link, useNavigate} from "react-router-dom";
import {AccountCircle} from "@mui/icons-material";

interface UserMenuProps {
    onClick?: () => void;
}

const UserMenu: React.FC<UserMenuProps> = ({onClick}) => {
    const {user, isAuthenticated, logout} = useAuth();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const navigate = useNavigate();

    function stringToColor(firstName: string, lastName: string) {
        const string = `${firstName}${lastName}`;
        let hash = 0;
        let i;

        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }

        return color;
    }

    const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        onClick && onClick();
    };

    const handleProfile = () => {
        navigate("/profile");
        handleMenuClose();
    }

    const handleLogout = () => {
        logout();
        handleMenuClose();
    }

    return isAuthenticated && user ? (
        <>
            <Tooltip title="Správa uživatelského účtu" arrow>
                <IconButton onClick={handleMenuClick} sx={{ml: 5}}>
                    <Avatar alt={user.username}
                            sx={{
                                backgroundColor: stringToColor(user.firstName, user.lastName),
                                width: 35,
                                height: 35,
                                border: "0.1px solid lightgray"
                            }}>
                        {user?.firstName.charAt(0).toUpperCase()}
                        {user?.lastName.charAt(0).toUpperCase()}
                    </Avatar>
                    <Typography variant="body1" color="white" sx={{ml: 1.5}}>
                        {user.username}
                    </Typography>
                </IconButton>
            </Tooltip>
            <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
                <MenuItem onClick={handleProfile}>Uživatelský profil</MenuItem>
                <Divider/>
                <MenuItem onClick={handleLogout}>Odhlásit se</MenuItem>
            </Menu>
        </>
    ) : (
        <Box sx={{ml: 5}}>
            <Link to="/login" style={{textDecoration: "none"}}>
                <Box sx={{display: "flex", alignItems: "center"}}>
                    <AccountCircle sx={{width: 30, height: 30, color: "white"}}/>
                    <NavButton name="Přihlášení" to="/login"/>
                </Box>
            </Link>
        </Box>
    );
}

export default UserMenu;